/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.placeholders.init());

App.modal_ready(() => App.placeholders.init());


App.placeholders = {
  init() {
    return App.placeholders.multi_init();
  },


  // Allow multi-line placeholders in textareas
  multi_init() {
    $(document)
      .off("focus", ".js-multiline-placeholder", App.placeholders.multi_focused)
      .on("focus", ".js-multiline-placeholder", App.placeholders.multi_focused);

    $(document)
      .off("blur", ".js-multiline-placeholder", App.placeholders.multi_blurred)
      .on("blur", ".js-multiline-placeholder", App.placeholders.multi_blurred);

    // When invite mode tabs change, disable hidden textareas so browser skips validation
    $(document)
      .off("click", "[data-toggle='pill']", App.placeholders.toggle_hidden_fields)
      .on("click", "[data-toggle='pill']", App.placeholders.toggle_hidden_fields);

    return $(".js-multiline-placeholder").each(function() {
      return App.placeholders.multi_setup(this);
    });
  },

  toggle_hidden_fields() {
    // Delay to let the tab pane visibility update first
    setTimeout(function() {
      $(".js-multiline-placeholder").each(function() {
        const hidden = !$(this).is(":visible");
        $(this).prop("disabled", hidden);
        // do not unset the custom validity if disabled,
        // leave it in case it is re enabled
      });
    }, 50);
  },

  multi_setup(el) {
    const $this = $(el);

    if (!$this.attr("data-placeholder")) {
      $this.attr("data-placeholder", $this.attr("placeholder"));
      $this.attr("placeholder", "");
      return $this.blur();
    }
  },


  multi_blurred(evt) {
    const $this = $(this);
    const placeholder_text = $this.attr("data-placeholder");
    const current_value = $this.val().replace(/\n/, '\\n');

    // There is no user input, show the placeholder
    if (!current_value || (current_value === placeholder_text)) {
      $this.css("color", "#bbb");
      $this.val(placeholder_text.replace('\\n', "\n"));

      // Since we're faking the placeholder text with real text,
      // we have to force the field to be invalid
      return this.setCustomValidity("This field is required");
    } else {
      // There is user input
      $this.css("color", "inherit");
      return this.setCustomValidity("");
    }
  },


  multi_focused(evt) {
    const $this = $(this);
    const placeholder_text = $this.attr("data-placeholder");
    const current_value = $this.val().replace(/\n/, '\\n');

    if (current_value === placeholder_text) {
      $this.val("");
      return $this.css("color", "inherit");
    }
  }
};
